import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
import { ComponentTitle } from '@anwb/typography';
const popoverHeaderContainerStyles = ({ theme }) => css `
	padding: ${pxToRem(theme.spacing['500'])} ${pxToRem(theme.spacing['500'])} 0
		${pxToRem(theme.spacing['500'])};

	> * {
		display: inline-block;
	}
`;
export const PopoverHeaderContainer = styled.header `
	${popoverHeaderContainerStyles}
`;
export const popoverHeaderTitleStyles = ({ theme }) => css `
	padding-right: ${pxToRem(theme.spacing['400'])};
	padding-bottom: ${pxToRem(theme.spacing['300'])};
`;
export const PopoverHeaderTitle = styled(ComponentTitle) `
	${popoverHeaderTitleStyles}
`;
//# sourceMappingURL=popover-header.styled.js.map